import Fuse from 'fuse.js';
import type {DatasetGroup} from '@gl/lit/types/datasets.js';
import type {Model} from './architecture.js';
import {isNil} from '@gl/lit/utils/index.js';

export function buildHref(datasetGroupId?: number) {
  if (isNil(datasetGroupId)) return undefined;

  const url = new URL(
    `/v2/dataset_groups/${datasetGroupId}`,
    window.location.href
  );

  return url.toString();
}

export function filterDatasetGroups(
  datasetGroups: DatasetGroup[],
  filterTerm: string
): DatasetGroup[] {
  const term = filterTerm.trim();

  if (term.length === 0) {
    return datasetGroups;
  }

  const options = {
    isCaseSensitive: false,
    includeScore: true,
    threshold: 0.6,
    shouldSort: true,
    keys: ['name'],
  };
  const fuse = new Fuse(datasetGroups, options);
  const result = fuse.search(filterTerm);
  return result.map(({item}) => item);
}

export const isTheMostFrequentlyUsedDataset = (idx: number, model: Model) => {
  return (
    idx === 0 &&
    (!model.filterTerm ||
      model.filteredDatasetGroups.length === model.datasetGroups.length)
  );
};
